<div class="!mx-auto !max-w-7xl !px-4 !py-6 sm:!py-8">
    <nav class="settings-tabs" aria-label="Sezioni impostazioni società">
        <button type="button" class="settings-tab" [class.is-active]="tabNumber === 0" (click)="setTabNumber(0)">Generali</button>
        <button type="button" class="settings-tab" [class.is-active]="tabNumber === 1" (click)="setTabNumber(1)">Pagamento</button>
        <button type="button" class="settings-tab" [class.is-active]="tabNumber === 2" (click)="setTabNumber(2)">Utenti</button>
        <button type="button" class="settings-tab" [class.is-active]="tabNumber === 3" (click)="setTabNumber(3)">Documenti atleti</button>
        <button type="button" class="settings-tab" [class.is-active]="tabNumber === 4" (click)="setTabNumber(4)">Documenti Well Done</button>
        <button type="button" class="settings-tab" [class.is-active]="tabNumber === 5" (click)="setTabNumber(5)">Abbonamento</button>
    </nav>

    <app-companies-settings-skeleton *ngIf="pageLoading && tabNumber === 0"></app-companies-settings-skeleton>
    <ng-container *ngIf="!pageLoading">
    <ng-container *ngIf="tabNumber === 0">
        <app-companies-settings-general
            [company]="company"
            [companyRaw]="companyRaw"
            [provinces]="provinces"
            [cities]="cities"
            [legalCities]="legalCities"
            [agents]="agents"
            [teamUsers]="linkedCompanyTeamUsers"
            [hasGlobalVisibility]="hasGlobalVisibility"
            [companyHasShop]="companyHasShop"
            [isSuperAdmin]="isSuperAdmin()"
            [canEditPaymentMethod]="canEditPaymentMethod"
            [saving]="savingCompany"
            [approving]="approvingCompany"
            [rulesUrl]="responseCompanyRules"
            [signatureUrl]="responseCompanySignature"
            [uploadingFields]="legalDocumentUploading"
            (save)="updateCompany()"
            (approve)="approveCompany(companyId)"
            (refuse)="refuseCompany(companyId)"
            (provinceChange)="updateCitiesLegal()"
            (legalProvinceChange)="updateLegalResidenceCities()"
            (rulesChange)="chooseRulesDocument($event)"
            (signatureChange)="chooseSignatureFile($event)"
            (legalDocumentChange)="uploadLegalDocument($event.field, $event.event)"
            (copyValue)="copyToClipboard($event)"
            (logoChange)="updateCompanyPicture($event)">
        </app-companies-settings-general>
    </ng-container>

<ng-container *ngIf="tabNumber === 1">
    <div class="welldone-card">
        <div class="welldone-card-header">
            Metodi di pagamento
        </div>
        <div class="welldone-card-body">
            <div class="payment-methods w-full space-y-7" id="accordionFlushExample">
                <section *ngFor="let enabled of [true, false]" class="payment-method-group"
                         [attr.aria-labelledby]="enabled ? 'payment-methods-enabled' : 'payment-methods-disabled'">
                    <div class="payment-method-group-heading">
                        <div>
                            <h3 [id]="enabled ? 'payment-methods-enabled' : 'payment-methods-disabled'" class="mb-0 text-sm font-semibold text-strong">
                                {{ enabled ? 'Attivi' : 'Disattivati' }}
                            </h3>
                            <p class="mb-0 mt-1 text-sm text-slate-600">
                                {{ enabled ? 'Metodi disponibili per i pagamenti.' : 'Metodi non disponibili per i pagamenti.' }}
                            </p>
                        </div>
                        <span class="payment-method-count">{{ enabled ? enabledPaymentMethodsCount : 6 - enabledPaymentMethodsCount }}</span>
                    </div>
                    <div class="space-y-3">
                        <p *ngIf="enabled && enabledPaymentMethodsCount === 0" class="payment-method-empty">Nessun metodo attivo. Usa l’interruttore in un metodo disattivato per abilitarlo.</p>
                        <p *ngIf="!enabled && enabledPaymentMethodsCount === 6" class="payment-method-empty">Tutti i metodi sono attivi.</p>

                <!-- Nexi -->
                <div *ngIf="!!company.nexiEnabled === enabled" class="border border-gray-200 rounded-xl overflow-hidden bg-white">
                    <div
                        class="accordion-container flex items-center justify-between px-4 py-2 transition-colors duration-200"
                        [ngClass]="{
                            'bg-gray-50': activePaymentPanel === 'Nexi',
                            'hover:bg-gray-50': activePaymentPanel !== 'Nexi'
                        }"
                    >
                        <button type="button" class="accordion-header-left accordion-header flex min-h-[44px] flex-1 items-center gap-3 border-0 bg-transparent p-0 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
                                [attr.aria-expanded]="activePaymentPanel === 'Nexi'" aria-controls="nexi-details" (click)="togglePaymentPanel('Nexi')">
                            <svg
                            class="h-4 w-4 text-gray-500 ml-1 transform transition-transform duration-200"
                            [ngClass]="{ 'rotate-90': activePaymentPanel === 'Nexi' }"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16 16"
                            fill="currentColor"
                        >
                            <path fill-rule="evenodd"
                                  d="M5.854 3.646a.5.5 0 0 0-.708.708L8.293 7.5 5.146 10.646a.5.5 0 1 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708z"/>
                        </svg>
                            <img src="assets/icons/nexiLogo.svg" alt="credit-card" class="h-4 w-auto" />
                            <span class="font-medium text-gray-800">Carta di credito e bancomat</span>
                        </button>
                        <div class="accordion-header-right flex items-center gap-3">
                            <button
                                type="button" aria-label="Modifica carta di credito e bancomat"
                                class="btn welldone-btn-light"
                                (click)="editPaymentMethod($event, 'Nexi')"
                                *ngIf="canEditPaymentMethod"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                     class="bi bi-pencil-fill" viewBox="0 0 16 16">
                                    <path
                                        d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                </svg>
                            </button>
                            <div class="form-check form-switch me-3">
                                <input class="form-check-input" type="checkbox" role="switch" id="nexiEnable"
                                       aria-label="Abilita carta di credito e bancomat" [checked]="company.nexiEnabled" (change)="enableDisableNexi()" />
                            </div>
                        </div>
                    </div>

                    <div id="nexi-details" *ngIf="activePaymentPanel === 'Nexi'" class="border-t border-slate-200 px-4 py-4">
                        <dl class="mb-0 grid gap-4 text-sm sm:grid-cols-2">
                            <div><dt class="mb-1 font-medium text-slate-600">Nexi Product ID</dt><dd class="mb-0 break-all font-semibold text-strong">{{ company.nexiShopId || 'Non configurato' }}</dd></div>
                            <div><dt class="mb-1 font-medium text-slate-600">Nexi API Key</dt><dd class="mb-0 break-all font-semibold text-strong">{{ company.nexiApiKey ? 'Configurata' : 'Non configurata' }}</dd></div>
                        </dl>
                    </div>
                </div>

                <!-- Bonifico Bancario -->
                <div *ngIf="!!company.wireTransferEnabled === enabled" class="border border-gray-200 rounded-xl overflow-hidden bg-white">
                    <div
                        class="accordion-container flex items-center justify-between px-4 py-2 transition-colors duration-200"
                        [ngClass]="{
                            'bg-gray-50': activePaymentPanel === 'WireTransfer',
                            'hover:bg-gray-50': activePaymentPanel !== 'WireTransfer'
                        }"
                    >
                    <button type="button" class="accordion-header-left accordion-header flex min-h-[44px] flex-1 items-center gap-3 border-0 bg-transparent p-0 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
                            [attr.aria-expanded]="activePaymentPanel === 'WireTransfer'" aria-controls="wire-transfer-details" (click)="togglePaymentPanel('WireTransfer')">
                        <svg
                            class="h-4 w-4 text-gray-500 ml-1 transform transition-transform duration-200"
                            [ngClass]="{ 'rotate-90': activePaymentPanel === 'WireTransfer' }"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16 16"
                            fill="currentColor"
                        >
                            <path fill-rule="evenodd"
                                  d="M5.854 3.646a.5.5 0 0 0-.708.708L8.293 7.5 5.146 10.646a.5.5 0 1 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708z"/>
                        </svg>
                        <img src="assets/icons/wire-transfer.png" alt="credit-card" class="h-6 w-auto"/>
                        <span class="font-medium text-gray-800">Bonifico Bancario</span>
                    </button>
                        <div class="accordion-header-right flex items-center gap-3">
                            <button
                                type="button" aria-label="Modifica bonifico bancario"
                                class="btn welldone-btn-light"
                                (click)="editPaymentMethod($event, 'WireTransfer')"
                                *ngIf="canEditPaymentMethod"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                     class="bi bi-pencil-fill" viewBox="0 0 16 16">
                                    <path
                                        d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                </svg>
                            </button>
                            <div class="form-check form-switch me-3">
                                <input class="form-check-input" type="checkbox" role="switch" id="wireTransferEnable"
                                       aria-label="Abilita bonifico bancario" [checked]="company.wireTransferEnabled"
                                       (change)="enableDisableWireTransferEnabled()" />
                            </div>
                        </div>
                    </div>
                    <div id="wire-transfer-details" *ngIf="activePaymentPanel === 'WireTransfer'" class="border-t border-slate-200 px-4 py-4">
                        <dl class="mb-0 grid gap-4 text-sm sm:grid-cols-2">
                            <div><dt class="mb-1 font-medium text-slate-600">IBAN</dt><dd class="mb-0 break-all font-semibold text-strong">{{ company.wireTransferIban || 'Non configurato' }}</dd></div>
                            <div><dt class="mb-1 font-medium text-slate-600">Beneficiario</dt><dd class="mb-0 break-all font-semibold text-strong">{{ company.wireTransferBeneficiary || 'Non configurato' }}</dd></div>
                        </dl>
                    </div>
                </div>

                <!-- Rate Mensili PagoDIL -->
                <div *ngIf="!!company.nexiRatesEnabled === enabled" class="border border-gray-200 rounded-xl overflow-hidden bg-white">
                    <div
                        class="accordion-container flex items-center justify-between px-4 py-2 transition-colors duration-200"
                        [ngClass]="{
                            'bg-gray-50': activePaymentPanel === 'NexiRates',
                            'hover:bg-gray-50': activePaymentPanel !== 'NexiRates'
                        }"
                    >
                        <button type="button" class="accordion-header-left accordion-header flex min-h-[44px] flex-1 items-center gap-3 border-0 bg-transparent p-0 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
                                [attr.aria-expanded]="activePaymentPanel === 'NexiRates'" aria-controls="nexi-rates-details" (click)="togglePaymentPanel('NexiRates')">
                            <svg
                            class="h-4 w-4 text-gray-500 ml-1 transform transition-transform duration-200"
                            [ngClass]="{ 'rotate-90': activePaymentPanel === 'NexiRates' }"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16 16"
                            fill="currentColor"
                        >
                            <path fill-rule="evenodd"
                                  d="M5.854 3.646a.5.5 0 0 0-.708.708L8.293 7.5 5.146 10.646a.5.5 0 1 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708z"/>
                        </svg>
                            <img src="assets/icons/pagodil.png" alt="credit-card" class="h-4 w-auto" />
                            <span class="font-medium text-gray-800">Rate Mensili PagoDIL</span>
                        </button>
                        <div class="accordion-header-right flex items-center gap-3">
                            <button
                                type="button" aria-label="Modifica rate mensili PagoDIL"
                                class="btn welldone-btn-light"
                                (click)="editPaymentMethod($event, 'NexiRates')"
                                *ngIf="canEditPaymentMethod"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                     class="bi bi-pencil-fill" viewBox="0 0 16 16">
                                    <path
                                        d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                </svg>
                            </button>
                            <div class="form-check form-switch me-3">
                                <input class="form-check-input" type="checkbox" role="switch" id="nexiRatesEnable"
                                       aria-label="Abilita rate mensili PagoDIL" [checked]="company.nexiRatesEnabled" (change)="enableDisableNexiRates()" />
                            </div>
                        </div>
                    </div>
                    <div id="nexi-rates-details" *ngIf="activePaymentPanel === 'NexiRates'" class="border-t border-slate-200 px-4 py-4">
                        <dl class="mb-0 grid gap-4 text-sm sm:grid-cols-2">
                            <div><dt class="mb-1 font-medium text-slate-600">Nexi Product ID</dt><dd class="mb-0 break-all font-semibold text-strong">{{ company.nexiRatesShopId || 'Non configurato' }}</dd></div>
                            <div><dt class="mb-1 font-medium text-slate-600">Nexi API Key</dt><dd class="mb-0 break-all font-semibold text-strong">{{ company.nexiRatesApiKey ? 'Configurata' : 'Non configurata' }}</dd></div>
                            <div><dt class="mb-1 font-medium text-slate-600">Commissione</dt><dd class="mb-0 font-semibold text-strong">{{ company.nexiRatesCommissionPercent == null ? 'Non configurata' : company.nexiRatesCommissionPercent + '%' }}</dd></div>
                        </dl>
                    </div>
                </div>

                <!-- Rate AppPago -->
                <div *ngIf="!!company.appPagoRatesEnabled === enabled" class="border border-gray-200 rounded-xl overflow-hidden bg-white">
                    <div
                        class="accordion-container flex items-center justify-between px-4 py-2 transition-colors duration-200"
                        [ngClass]="{
                            'bg-gray-50': activePaymentPanel === 'AppPagoRates',
                            'hover:bg-gray-50': activePaymentPanel !== 'AppPagoRates'
                        }"
                    >
                        <button type="button" class="accordion-header-left accordion-header flex min-h-[44px] flex-1 items-center gap-3 border-0 bg-transparent p-0 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
                                [attr.aria-expanded]="activePaymentPanel === 'AppPagoRates'" aria-controls="app-pago-details" (click)="togglePaymentPanel('AppPagoRates')">
                            <svg
                                class="h-4 w-4 text-gray-500 ml-1 transform transition-transform duration-200"
                                [ngClass]="{ 'rotate-90': activePaymentPanel === 'AppPagoRates' }"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 16 16"
                                fill="currentColor"
                            >
                                <path fill-rule="evenodd"
                                        d="M5.854 3.646a.5.5 0 0 0-.708.708L8.293 7.5 5.146 10.646a.5.5 0 1 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708z"/>
                            </svg>
                            <img src="assets/icons/appPago.svg" alt="credit-card" class="h-4 w-auto" />
                            <span class="font-medium text-gray-800">Rate AppPago</span>
                        </button>
                        <div class="accordion-header-right flex items-center gap-3">
                            <button
                                type="button" aria-label="Modifica rate AppPago"
                                class="btn welldone-btn-light"
                                (click)="editPaymentMethod($event, 'AppPagoRates')"
                                *ngIf="canEditPaymentMethod"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                        class="bi bi-pencil-fill" viewBox="0 0 16 16">
                                    <path
                                        d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                </svg>
                            </button>
                            <div class="form-check form-switch me-3">
                                <input class="form-check-input" type="checkbox" role="switch" id="appPagoRatesEnabled"
                                        aria-label="Abilita rate AppPago" [checked]="company.appPagoRatesEnabled" (change)="enableDisableAppPagoRates()" />
                            </div>
                        </div>
                    </div>
                    <div id="app-pago-details" *ngIf="activePaymentPanel === 'AppPagoRates'" class="border-t border-slate-200 px-4 py-4">
                        <dl class="mb-0 grid gap-4 text-sm sm:grid-cols-2">
                            <div><dt class="mb-1 font-medium text-slate-600">AppPago Shop ID</dt><dd class="mb-0 break-all font-semibold text-strong">{{ company.appPagoShopId || 'Non configurato' }}</dd></div>
                            <div><dt class="mb-1 font-medium text-slate-600">AppPago API Key</dt><dd class="mb-0 break-all font-semibold text-strong">{{ company.appPagoApiKey ? 'Configurata' : 'Non configurata' }}</dd></div>
                            <div><dt class="mb-1 font-medium text-slate-600">AppPago API Secret</dt><dd class="mb-0 break-all font-semibold text-strong">{{ company.appPagoApiSecret ? 'Configurato' : 'Non configurato' }}</dd></div>
                            <div><dt class="mb-1 font-medium text-slate-600">Commissione</dt><dd class="mb-0 font-semibold text-strong">{{ company.appPagoCommissionPercent == null ? 'Non configurata' : company.appPagoCommissionPercent + '%' }}</dd></div>
                        </dl>
                    </div>
                </div>
                <!-- Pos Nexi -->
                <div *ngIf="!!company.posNexiEnabled === enabled" class="border border-gray-200 rounded-xl overflow-hidden bg-white">
                    <div
                        class="accordion-container flex items-center justify-between px-4 py-2 transition-colors duration-200"
                        [ngClass]="{
                            'bg-gray-50': activePaymentPanel === 'NexiPos',
                            'hover:bg-gray-50': activePaymentPanel !== 'NexiPos'
                        }"
                    >
                        <button type="button" class="accordion-header-left accordion-header flex min-h-[44px] flex-1 items-center gap-3 border-0 bg-transparent p-0 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
                                [attr.aria-expanded]="activePaymentPanel === 'NexiPos'" aria-controls="nexi-pos-details" (click)="togglePaymentPanel('NexiPos')">
                            <svg
                                class="h-4 w-4 text-gray-500 ml-1 transform transition-transform duration-200"
                                [ngClass]="{ 'rotate-90': activePaymentPanel === 'NexiPos' }"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 16 16"
                                fill="currentColor"
                            >
                                <path fill-rule="evenodd"
                                      d="M5.854 3.646a.5.5 0 0 0-.708.708L8.293 7.5 5.146 10.646a.5.5 0 1 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708z"/>
                            </svg>
                            <img src="assets/icons/pos-svgrepo-com.svg" alt="pos" class="h-4 w-auto" />
                            <span class="font-medium text-gray-800">POS Nexi</span>
                        </button>
                        <div class="accordion-header-right flex items-center gap-3">
                            <button
                                class="btn welldone-btn-light"
                                (click)="editPaymentMethod($event, 'NexiPos')"
                                *ngIf="canEditPaymentMethod"
                                aria-label="Modifica POS Nexi"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                     class="bi bi-pencil-fill" viewBox="0 0 16 16">
                                    <path
                                        d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                </svg>
                            </button>
                            <div class="form-check form-switch me-3">
                                <input class="form-check-input" type="checkbox" role="switch" id="posNexiEnable"
                                       aria-label="Abilita POS Nexi" [checked]="company.posNexiEnabled" (click)="$event.stopPropagation()" (change)="enableDisablePosNexi()" />
                            </div>
                        </div>
                    </div>
                    <div id="nexi-pos-details" *ngIf="activePaymentPanel === 'NexiPos'" class="border-t border-slate-200 px-4 py-4">
                        <dl class="mb-0 grid gap-4 text-sm sm:grid-cols-2">
                            <div>
                                <dt class="mb-1 font-medium text-slate-600">Id azienda</dt>
                                <dd class="mb-0 break-all font-semibold text-strong">{{ company.posNexiBusinessId || 'Non configurato' }}</dd>
                            </div>
                            <div>
                                <dt class="mb-1 font-medium text-slate-600">Terminale POS</dt>
                                <dd class="mb-0 break-all font-semibold text-strong">{{ selectedPosNexiTerminalLabel() }}</dd>
                            </div>
                        </dl>
                        <div class="mt-4 border-t border-slate-200 pt-4">
                            <h4 class="mb-1 text-sm font-semibold text-strong">Pagamenti a rate</h4>
                            <p class="mb-3 text-sm leading-6 text-slate-600">Per i pagamenti a rate servono Alias e Chiave MAC da XPay.</p>
                            <dl class="mb-0 grid gap-4 text-sm sm:grid-cols-2">
                                <div><dt class="mb-1 font-medium text-slate-600">Alias XPay</dt><dd class="mb-0 break-all font-semibold text-strong">{{ company.posNexiShopId || 'Non configurato' }}</dd></div>
                                <div><dt class="mb-1 font-medium text-slate-600">Chiave MAC</dt><dd class="mb-0 font-semibold text-strong">{{ company.posNexiApiKey ? 'Configurata' : 'Non configurata' }}</dd></div>
                            </dl>
                        </div>
                    </div>
                </div>

                <!-- Pagamento in segreteria -->
                <div *ngIf="!!company.localPaymentEnabled === enabled" class="border border-gray-200 rounded-xl overflow-hidden bg-white">
                    <div class="accordion-container flex items-center justify-between px-4 py-3">
                        <div class="accordion-header-left accordion-header flex items-center gap-3">
                            <img src="assets/icons/cashPayment.png" alt="credit-card" class="h-6 w-auto" />
                            <span class="font-medium text-gray-800">Pagamento in segreteria</span>
                        </div>
                        <div class="accordion-header-right flex items-center gap-3">
                            <div class="form-check form-switch me-3">
                                <input class="form-check-input" type="checkbox" role="switch" id="localPaymentEnable"
                                       [checked]="company.localPaymentEnabled" (change)="enableDisableLocalPayment()" />
                            </div>
                        </div>
                    </div>
                </div>

                    </div>
                </section>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="tabNumber === 2">
    <app-companies-settings-team
        [users]="linkedCompanyTeamUsers"
        [company]="company"
        [loading]="linkedCompanyTeamLoading"
        [isSuperAdmin]="isSuperAdmin()"
        [roleName]="getUserRoleDisplayName"
        [initials]="teamMemberInitials"
        (addPerson)="openUserModal()"
        (editPerson)="openUserModal($event)"
        (removePerson)="deleteUser($event)"
        (loginAs)="loginAsUser($event)">
    </app-companies-settings-team>
</ng-container>
<ng-container *ngIf="tabNumber === 3">
    <p class="welldone-text-gray" style="font-size: 14px;">In questa sezione vengono caricati tutti i documenti richiesti
        agli atleti da parte della società sportiva.</p>
    <div class="welldone-card mb-4">
        <div class="welldone-card-header">
            Aggiungi/Modifica Documento
        </div>
        <div class="welldone-card-body">
            <form #athleteDocumentForm="ngForm" class="w-100">

                <div class="container-fluid">
                    <div class="row mb-3">
                        <div class="col-4">
                            <span class="required">Nome documento</span>
                        </div>
                        <div class="col-8">
                            <input type="text" class="form-control form-control-solid"
                                   [(ngModel)]="athleteDocument.name" name="document-name" required/>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4"><span>Descrizione</span></div>
                        <div class="col-8"><textarea class="form-control form-control-solid"
                                                     [(ngModel)]="athleteDocument.description"
                                                     name="document-description"></textarea></div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4"><span class="required">Tipologia documento</span></div>
                        <div class="col-8">
                            <welldone-multiselect
                                    [placeholder]="'Seleziona tipologia documento'"
                                    [settings]="TypeDropdownSettings"
                                    [data]="documentTypes"
                                    [(ngModel)]="selectedDocumentTypes"
                                    name="document-types">
                            </welldone-multiselect>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4"><span class="required"> E' obbligatorio</span></div>
                        <div class="col-8">
                            <select class="form-control form-select form-select-solid"
                                    [(ngModel)]="athleteDocument.isMandatory" name="document-mandatory" required>
                                <option value="1" selected>
                                    Sì
                                </option>
                                <option value="0">
                                    No
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4"><span class="required">Ha una data di scadenza?</span></div>
                        <div class="col-8">
                            <select class="form-control form-select form-select-solid"
                                    [(ngModel)]="athleteDocument.hasExpirationDate" name="document-expire" required>
                                <option value="1" selected>
                                    Sì
                                </option>
                                <option value="0">
                                    No
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4"><span class="required">È un documento primario?</span></div>
                        <div class="col-8">
                            <select class="form-control form-select form-select-solid"
                                    [(ngModel)]="athleteDocument.primaryDocument" name="document-primary" required
                                    [disabled]="primaryDocumentExists">
                                <option value="1">
                                    Sì
                                </option>
                                <option value="0" selected>
                                    No
                                </option>
                            </select>
                            <div class="primary-document alert alert-dark" *ngIf="primaryDocumentExists">
                                Si può inserire solo un documento primario
                            </div>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-4">
                            <label for="model-document"
                                   class="form-label">Modello documento</label>
                        </div>
                        <div class="col-8">
                            <input type="file" class="form-control form-control-solid" id="model-document"
                                   aria-describedby="model-document" aria-label="Upload"
                                   (change)="chooseDocumentModel($event)"
                                   name="model-document"
                            />
                            <div *ngIf="showModelDocumentPreview">
                                <a [href]="modelDocumentUrl">Visualizza il documento caricato</a>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="welldone-card-footer d-flex justify-content-end">
            <button class="btn btn-primary " [disabled]="athleteDocumentForm.invalid" (click)="uploadDocument($event)">
                Salva
            </button>
        </div>
    </div>

    <ui-table #athleteDocumentsTable table-title="Documenti caricati">
        <ng-template #customHeader>
            <tr>
                <th>Nome</th>
                <th>Descrizione</th>
                <th>Tipologia</th>
                <th>Richiesto</th>
                <th>Ha Scadenza?</th>
                <th>Anteprima Modulo</th>
                <th *ngIf="primaryDocumentExists">È un documento primario?</th>
                <th>Modifica / Elimina</th>
            </tr>
        </ng-template>

        <ng-template #customRow let-row="row">
            <tr>
                <td> {{ row.name }}</td>
                <td> {{ row.description ?? '' }}</td>
                <td>
                    <ng-container *ngIf="getDocumentTypesLabels(row.documentTypes).length; else noDocumentTypes">
                        <div *ngFor="let typeLabel of getDocumentTypesLabels(row.documentTypes)">
                            {{ typeLabel }}
                        </div>
                    </ng-container>
                    <ng-template #noDocumentTypes>
                        Nessuna tipologia
                    </ng-template>
                </td>
                <td>
                    <span class="badge badge-success" *ngIf="row.isMandatory"> Obbligatorio</span>
                    <span class="badge badge-error" *ngIf="!row.isMandatory"> Non obbligatorio</span>
                </td>
                <td>
                    <span class="badge badge-success" *ngIf="row.hasExpirationDate"> Con scadenza</span>
                    <span class="badge badge-error" *ngIf="!row.hasExpirationDate"> Senza scadenza</span>
                </td>
                <td>
                    <a *ngIf="row.modelUrl && row.modelUrl !== ''" [href]="row.modelUrl">Visualizza Anteprima</a>
                </td>
                <td *ngIf="primaryDocumentExists">
                    <div *ngIf="row.primaryDocument">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor"
                             class="bi bi-check" viewBox="0 0 16 16">
                            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
                        </svg>
                    </div>
                </td>
                <td>
                    <div class="d-flex justify-content-start gap-3">
                        <button class="btn welldone-btn-gray" (click)="openEditDocumentModal(row)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                 class="bi bi-pencil" viewBox="0 0 16 16">
                                <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                            </svg>
                        </button>
                        <button class="btn welldone-btn-gray" (click)="removeDocumentModel(row)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                 class="bi bi-trash" viewBox="0 0 16 16">
                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                            </svg>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </ui-table>

</ng-container>
<ng-container *ngIf="tabNumber === 4">
    <ui-table #adminDocumentsTable table-title="Documenti necessari">
        <ng-template #customHeader>
            <tr>
                <th>Documento</th>
                <th>Obbligatorio</th>
                <th>Stato</th>
                <th>File</th>
                <th></th>
            </tr>
        </ng-template>

        <ng-template #customRow let-row="row">
            <tr>
                <td> {{ row.name }}</td>
                <td>
                    <span class="badge badge-success" *ngIf="row.isMandatory"> Sì </span>
                    <span class="badge badge-error" *ngIf="!row.isMandatory"> No </span>
                </td>
                <td>
                    <span class="badge badge-success" *ngIf="row.uploadStatus === 'approved'"> Approvato </span>
                    <span class="badge badge-warning"
                          *ngIf="row.uploadStatus === 'pending'"> In attesa di verifica </span>
                    <span class="badge badge-error" *ngIf="row.uploadStatus === 'rejected'"> Rifiutato </span>
                    <span class="badge badge-error" *ngIf="row.uploadStatus === 'notUploaded'"> Non caricato </span>
                </td>
                <td>
                    <a *ngIf="row.url && row.url !== ''" [href]="row.url">Anteprima</a>
                </td>
                <td>
                    <ng-container *ngIf="row.uploadStatus !== 'notUploaded'; else notUploaded">
                        <div class="d-flex justify-content-end gap-3">
                            <button class="btn welldone-btn-gray" (click)="reuploadFile()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                     class="bi bi-pencil" viewBox="0 0 16 16">
                                    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                                </svg>
                            </button>
                            <div *ngIf="canApproveRejectCompanyDocument" class="d-flex justify-content-end gap-3">
                                <button class="btn welldone-btn-gray" (click)="approveDocument(row.id)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                         class="bi bi-check-lg" viewBox="0 0 16 16">
                                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                                    </svg>
                                </button>
                                <button class="btn welldone-btn-gray" (click)="rejectDocument(row.id)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                         class="bi bi-x-lg" viewBox="0 0 16 16">
                                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #notUploaded>
                        <!--Vuoto per eventuali messaggi-->
                    </ng-template>
                </td>
            </tr>
        </ng-template>
    </ui-table>

    <div class="welldone-card">
        <div class="welldone-card-header">
            Carica Documento
        </div>
        <div class="welldone-card-body">
            <div class="container-fluid w-100">
                <div class="row mb-3">
                    <div class="col-4"><span class="required"> Seleziona tipo di documento </span></div>
                    <div class="col-8">
                        <select required name="category" class="form-select form-select-solid"
                                [(ngModel)]="adminDocumentType">
                            <option value="">Seleziona una tipologia</option>
                            <option *ngFor="let document of adminDocuments"
                                    value="{{document.id}}">{{ document.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4"><span class="required"> Inserisci documento </span></div>
                    <div class="col-8">
                        <input type="file" class="form-control form-control-solid" id="document-type-input"
                               aria-describedby="document-type-input" aria-label="Upload"
                               (change)="chooseDocument($event)">
                    </div>
                </div>
            </div>
        </div>
        <div class="welldone-card-footer d-flex justify-content-end">
            <button class="btn btn-primary" (click)="uploadAdminDocument()">
                Carica documento
            </button>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="tabNumber === 5">
    <app-companies-settings-subscription
        [company]="company"
        [companyRaw]="companyRaw"
        [companyId]="companyId"
        [userIsSuperAdmin]="isSuperAdmin()"
        [canEditPaymentMethod]="canEditPaymentMethod"
        [currentInvoice]="currentInvoice"
        [currentCardDetails]="currentCardDetails"
        (reload)="onSubscriptionReloaded()"
        (updatePayment)="openUpdateStripePaymentModal()">
    </app-companies-settings-subscription>
</ng-container>

    </ng-container>
</div>

<!-- * Modal -->
<ngx-smart-modal #updateStripePaymentModal [identifier]="'updateStripePaymentModal'" [closable]="true"
                 (onOpen)="showUpdateStripePaymentContent = true" (onClose)="showUpdateStripePaymentContent = false">
    <div class="welldone-card-header">
        Aggiorna metodo di pagamento
    </div>
    <div class="welldone-card-body">
        <ng-container *ngIf="showUpdateStripePaymentContent">
            <app-stripe-embedded-checkout
                [updatePaymentMode]="true"
                [companyId]="companyId"
                (paymentCompleted)="onStripePaymentMethodUpdated()">
            </app-stripe-embedded-checkout>
        </ng-container>
    </div>
</ngx-smart-modal>

<ngx-smart-modal #editPaymentModal identifier="editPaymentModal" customClass="payment-settings-modal"
                 (onClose)="clearModalData('editPaymentModal')" [closable]="false">
    <ng-container *ngIf="editPaymentModal.hasData()">
        <div class="payment-modal">
            <header class="payment-modal-header">
                <div class="min-w-0">
                    <h2 class="mb-1 text-lg font-semibold text-strong" id="payment-modal-title">
                        {{ paymentMethodTitle(editPaymentModal.getData().type) }}
                    </h2>
                    <p class="mb-0 text-sm leading-5 text-slate-600">Modifica le impostazioni di questo metodo di pagamento.</p>
                </div>
                <button type="button" class="payment-modal-close" aria-label="Chiudi finestra"
                        (click)="editPaymentModal.close()">
                    <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" class="h-5 w-5">
                        <path d="M18 6 6 18M6 6l12 12"/>
                    </svg>
                </button>
            </header>

            <div class="payment-modal-body" aria-labelledby="payment-modal-title">
                <ng-container *ngIf="editPaymentModal.getData().wireTransfer; else onlinePaymentFields">
                    <div class="payment-modal-fields">
                        <div class="payment-modal-field">
                            <label for="iban" class="form-label required">IBAN</label>
                            <input type="text" class="form-control form-control-solid" id="iban" [(ngModel)]="editPaymentModal.getData().iban" autocomplete="off">
                        </div>
                        <div class="payment-modal-field">
                            <label for="beneficiary" class="form-label required">Beneficiario</label>
                            <input type="text" class="form-control form-control-solid" id="beneficiary" [(ngModel)]="editPaymentModal.getData().beneficiary" autocomplete="off">
                        </div>
                    </div>
                </ng-container>
                <ng-template #onlinePaymentFields>
                    <div *ngIf="!editPaymentModal.getData().posNexi" class="payment-modal-fields">
                        <div class="payment-modal-field">
                            <label for="shopId" class="form-label required">{{ editPaymentModal.getData().appPagoRates ? 'Shop ID' : 'Product ID' }}</label>
                            <input type="text" class="form-control form-control-solid" id="shopId" [(ngModel)]="editPaymentModal.getData().shopId" autocomplete="off">
                        </div>
                        <div class="payment-modal-field">
                            <label for="apiKey" class="form-label required">API Key</label>
                            <input type="text" class="form-control form-control-solid" id="apiKey" [(ngModel)]="editPaymentModal.getData().apiKey" autocomplete="off">
                        </div>
                        <div *ngIf="editPaymentModal.getData().appPagoRates" class="payment-modal-field">
                            <label for="apiSecret" class="form-label required">API Secret</label>
                            <input type="text" class="form-control form-control-solid" id="apiSecret" [(ngModel)]="editPaymentModal.getData().apiSecret" autocomplete="off">
                        </div>
                        <div *ngIf="editPaymentModal.getData().nexiRates || editPaymentModal.getData().appPagoRates" class="payment-modal-field">
                            <label for="commissionPercent" class="form-label required">Commissione (%)</label>
                            <input type="text" inputmode="decimal" class="form-control form-control-solid" id="commissionPercent" [(ngModel)]="editPaymentModal.getData().commissionPercent">
                        </div>
                    </div>
                    <div *ngIf="editPaymentModal.getData().posNexi" class="payment-modal-fields">
                        <div class="payment-modal-field">
                            <label for="posNexiBusinessId" class="form-label required">Id azienda</label>
                            <input type="text" class="form-control form-control-solid" id="posNexiBusinessId"
                                   [(ngModel)]="editPaymentModal.getData().posNexiBusinessId"
                                   (blur)="onPosNexiBusinessIdBlur(editPaymentModal.getData().posNexiBusinessId)" autocomplete="off">
                        </div>
                        <div class="payment-modal-field">
                            <div class="flex items-center justify-between gap-3">
                                <label for="posNexiDeviceId" class="form-label required mb-0">Terminale POS</label>
                                <button type="button" class="payment-modal-link" [disabled]="posNexiTerminalsLoading"
                                        (click)="loadPosNexiTerminals(editPaymentModal.getData().posNexiBusinessId)">Aggiorna elenco</button>
                            </div>
                            <select id="posNexiDeviceId" class="form-control form-select form-select-solid" [(ngModel)]="editPaymentModal.getData().posNexiDeviceId"
                                    [disabled]="posNexiTerminalsLoading || !posNexiTerminals.length">
                                <option value="">Seleziona un terminale</option>
                                <option *ngFor="let terminal of posNexiTerminals" [value]="terminal.deviceId">{{ posNexiTerminalLabel(terminal) }}</option>
                            </select>
                            <p *ngIf="posNexiTerminalsLoading" class="mb-0 text-sm text-slate-600" role="status">Caricamento terminali…</p>
                            <p *ngIf="!posNexiTerminalsLoading && posNexiTerminalsError" class="mb-0 text-sm text-danger" role="alert">{{ posNexiTerminalsError }}</p>
                            <p *ngIf="!posNexiTerminalsLoading && !posNexiTerminalsError && posNexiTerminals.length > 1" class="mb-0 text-sm text-slate-600">Verifica il terminale usato da questa società.</p>
                        </div>
                        <section class="payment-modal-section">
                            <h3 class="mb-1 text-sm font-semibold text-strong">Pagamenti a rate</h3>
                            <p class="mb-0 text-sm leading-5 text-slate-600">Per i pagamenti a rate servono Alias e Chiave MAC da XPay.</p>
                            <div class="payment-modal-fields mt-4">
                                <div class="payment-modal-field">
                                    <label for="posNexiShopId" class="form-label">Alias XPay</label>
                                    <input type="text" class="form-control form-control-solid" id="posNexiShopId" [(ngModel)]="editPaymentModal.getData().posNexiShopId" autocomplete="off">
                                </div>
                                <div class="payment-modal-field">
                                    <label for="posNexiApiKey" class="form-label">Chiave MAC</label>
                                    <div class="flex gap-2">
                                        <input [type]="showPosNexiMacKey ? 'text' : 'password'" class="form-control form-control-solid min-w-0" id="posNexiApiKey" [(ngModel)]="editPaymentModal.getData().posNexiApiKey" autocomplete="off">
                                        <button type="button" class="payment-modal-show-key" [attr.aria-label]="showPosNexiMacKey ? 'Nascondi chiave MAC' : 'Mostra chiave MAC'" (click)="showPosNexiMacKey = !showPosNexiMacKey">{{ showPosNexiMacKey ? 'Nascondi' : 'Mostra' }}</button>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </ng-template>
            </div>

            <footer class="payment-modal-footer">
                <button type="button" class="payment-modal-cancel" (click)="editPaymentModal.close()">Annulla</button>
                <button type="button" class="payment-modal-save" [disabled]="editPaymentModal.getData().posNexi && posNexiTerminalsLoading"
                        (click)="savePaymentModal()">Salva modifiche</button>
            </footer>
        </div>
    </ng-container>
</ngx-smart-modal>

<ngx-smart-modal #addUserModal identifier="addUserModal" [closable]="true"
                 customClass="nsm-dialog-animation-fade invite-user-modal-shell"
                 (onClose)="resetInviteUserForm()">
    <div class="w-full bg-white text-left">
        <div class="px-6 pt-6 pb-2 sm:px-8 sm:pt-8 border-b border-border">
            <p class="text-xs font-semibold uppercase tracking-wider text-primary">Nuovo accesso</p>
            <h2 class="mt-2 text-xl font-semibold text-strong">Aggiungi una persona alla società</h2>
            <p class="mt-3 text-sm text-subtle leading-relaxed">
                La persona riceverà l’accesso usando l’email e la password che inserisci qui. Sotto puoi decidere cosa può fare (ruolo): i nomi vengono dal sistema così sono sempre aggiornati.
            </p>
        </div>

        <div class="px-6 py-6 sm:px-8 space-y-8">
            <section class="space-y-3" aria-labelledby="invite-role-heading">
                <div class="flex items-baseline gap-2 flex-wrap">
                    <h3 id="invite-role-heading" class="text-sm font-semibold text-strong">Ruolo sulla piattaforma</h3>
                    <span class="text-xs text-subtle">(tocca una scheda)</span>
                </div>
                <p id="invite-role-help" class="text-sm text-subtle">
                    Scegli quello più vicino alla responsabilità reale della persona. Se non sei sicuro, chiedi a chi gestisce gli account in società o all’assistenza WellDone.
                </p>
                <div class="grid gap-2.5 sm:gap-3" role="radiogroup" aria-labelledby="invite-role-heading">
                    <button type="button"
                            *ngFor="let role of companyInviteRoleOptions"
                            role="radio"
                            [attr.aria-checked]="selectedInviteRoleId === role.id"
                            (click)="selectInviteRole(role.id)"
                            class="relative w-full text-left rounded-xl border px-4 py-3 sm:py-3.5 transition-all shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                            [ngClass]="selectedInviteRoleId === role.id
                                ? 'border-primary ring-2 ring-primary-soft bg-primary-soft'
                                : 'border-border bg-white hover:border-border hover:bg-canvas/90'">
                        <span class="flex items-start gap-3">
                            <span class="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 transition-colors"
                                  [ngClass]="selectedInviteRoleId === role.id ? 'border-primary bg-primary' : 'border-border bg-white'">
                                <svg class="h-3 w-3 text-white" *ngIf="selectedInviteRoleId === role.id" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M10 3L4.5 8.5L2 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                            <span class="min-w-0">
                                <span class="block font-medium text-strong leading-snug">{{ role.name }}</span>
                            </span>
                        </span>
                    </button>
                </div>
            </section>

            <!-- Campi specifici per ruolo -->
            <section *ngIf="isInviteRole('companymanager')" class="space-y-4" aria-labelledby="invite-cm-extra-heading">
                <h3 id="invite-cm-extra-heading" class="text-sm font-semibold text-strong">Contatti amministratore</h3>
                <p class="text-sm text-subtle">Facoltativo: utile per l’assistenza o le comunicazioni urgenti sulla società.</p>
                <div class="space-y-1.5">
                    <label for="inviteCompanyManagerPhone" class="block text-sm font-medium text-muted">Telefono</label>
                    <input type="tel" id="inviteCompanyManagerPhone" name="inviteCompanyManagerPhone" autocomplete="tel"
                           [(ngModel)]="newUser.phone"
                           class="block w-full rounded-lg border border-border bg-white px-3 py-2.5 text-sm text-strong shadow-sm placeholder:text-subtle/70 transition-shadow focus:outline-none focus:ring-0 focus:!border-primary focus:shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.25)]"
                           placeholder="es. +39 333 1234567"/>
                </div>
            </section>

            <section *ngIf="isInviteRole('accompagnatore')" class="space-y-4" aria-labelledby="invite-acc-extra-heading">
                <h3 id="invite-acc-extra-heading" class="text-sm font-semibold text-strong">Dati accompagnatore</h3>
                <p class="text-sm text-subtle">Facoltativo: numero raggiungibile durante trasferte o attività con la squadra.</p>
                <div class="space-y-1.5">
                    <label for="inviteAccompagnatorePhone" class="block text-sm font-medium text-muted">Telefono</label>
                    <input type="tel" id="inviteAccompagnatorePhone" name="inviteAccompagnatorePhone" autocomplete="tel"
                           [(ngModel)]="newUser.phone"
                           class="block w-full rounded-lg border border-border bg-white px-3 py-2.5 text-sm text-strong shadow-sm placeholder:text-subtle/70 transition-shadow focus:outline-none focus:ring-0 focus:!border-primary focus:shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.25)]"
                           placeholder="es. +39 333 1234567"/>
                </div>
            </section>

            <section *ngIf="isInviteRole('staff')" class="space-y-4" aria-labelledby="invite-staff-extra-heading">
                <h3 id="invite-staff-extra-heading" class="text-sm font-semibold text-strong">Dati staff</h3>
                <p class="text-sm text-subtle">Facoltativo: recapito interno per la società.</p>
                <div class="space-y-1.5">
                    <label for="inviteStaffPhone" class="block text-sm font-medium text-muted">Telefono</label>
                    <input type="tel" id="inviteStaffPhone" name="inviteStaffPhone" autocomplete="tel"
                           [(ngModel)]="newUser.phone"
                           class="block w-full rounded-lg border border-border bg-white px-3 py-2.5 text-sm text-strong shadow-sm placeholder:text-subtle/70 transition-shadow focus:outline-none focus:ring-0 focus:!border-primary focus:shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.25)]"
                           placeholder="es. +39 333 1234567"/>
                </div>
            </section>

            <section *ngIf="isInviteRole('mister')" class="space-y-3" aria-labelledby="invite-mister-cat-heading">
                <div class="flex items-baseline gap-2 flex-wrap">
                    <h3 id="invite-mister-cat-heading" class="text-sm font-semibold text-strong">Categorie assegnate</h3>
                    <span class="text-xs text-subtle">(seleziona almeno una)</span>
                </div>
                <p id="invite-mister-cat-help" class="text-sm text-subtle">
                    Il mister vedrà convocazioni e attività solo per le categorie che selezioni qui. Puoi modificarle in seguito se il backend lo consente.
                </p>
                <p *ngIf="inviteMisterCategoriesLoading" class="text-sm text-muted">Caricamento categorie…</p>
                <div *ngIf="!inviteMisterCategoriesLoading && inviteMisterCategoryOptions.length === 0" class="rounded-lg border border-border bg-canvas/80 px-4 py-3 text-sm text-muted">
                    Non risultano categorie per la stagione corrente. Crea le categorie in anagrafia o verifica la stagione, poi riprova.
                </div>
                <div *ngIf="!inviteMisterCategoriesLoading && inviteMisterCategoryOptions.length > 0"
                     class="w-full"
                     aria-labelledby="invite-mister-cat-heading"
                     aria-describedby="invite-mister-cat-help">
                    <welldone-multiselect
                            [placeholder]="'Cerca e seleziona una o più categorie'"
                            [settings]="TypeDropdownSettings"
                            [data]="inviteMisterCategoryOptions"
                            [(ngModel)]="inviteMisterCategoriesSelected"
                            name="invite-mister-categories">
                    </welldone-multiselect>
                </div>
            </section>

            <section class="space-y-4" aria-labelledby="invite-person-heading">
                <h3 id="invite-person-heading" class="text-sm font-semibold text-strong">Dati della persona</h3>
                <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div class="space-y-1.5">
                        <label for="inviteFirstName" class="block text-sm font-medium text-muted">
                            Nome <span class="text-red-500" aria-hidden="true">*</span>
                        </label>
                        <input type="text" id="inviteFirstName" name="inviteFirstName" autocomplete="given-name"
                               [(ngModel)]="newUser.firstName"
                               class="block w-full rounded-lg border border-border bg-white px-3 py-2.5 text-sm text-strong shadow-sm placeholder:text-subtle/70 transition-shadow focus:outline-none focus:ring-0 focus:!border-primary focus:shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.25)]"
                               placeholder="es. Paolo"/>
                    </div>
                    <div class="space-y-1.5">
                        <label for="inviteLastName" class="block text-sm font-medium text-muted">
                            Cognome <span class="text-red-500" aria-hidden="true">*</span>
                        </label>
                        <input type="text" id="inviteLastName" name="inviteLastName" autocomplete="family-name"
                               [(ngModel)]="newUser.lastName"
                               class="block w-full rounded-lg border border-border bg-white px-3 py-2.5 text-sm text-strong shadow-sm placeholder:text-subtle/70 transition-shadow focus:outline-none focus:ring-0 focus:!border-primary focus:shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.25)]"
                               placeholder="es. Rossi"/>
                    </div>
                </div>
                <div class="space-y-1.5">
                    <label for="inviteEmail" class="block text-sm font-medium text-muted">
                        Email (serve per entrare nel portale) <span class="text-red-500" aria-hidden="true">*</span>
                    </label>
                    <input type="email" id="inviteEmail" name="inviteEmail" autocomplete="email"
                           [(ngModel)]="newUser.email"
                           class="block w-full rounded-lg border border-border bg-white px-3 py-2.5 text-sm text-strong shadow-sm placeholder:text-subtle/70 transition-shadow focus:outline-none focus:ring-0 focus:!border-primary focus:shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.25)]"
                           placeholder="nome@posta.it"/>
                    <p class="text-xs text-subtle">Deve essere un indirizzo reale alla quale la persona ha accesso.</p>
                </div>
            </section>

            <section class="space-y-4" aria-labelledby="invite-password-heading">
                <h3 id="invite-password-heading" class="text-sm font-semibold text-strong">Password temporanea</h3>
                <p class="text-sm text-subtle">Sceglila tu ora; la persona potrà cambiarla dopo il primo accesso se preferisce.</p>
                <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div class="space-y-1.5">
                        <label for="invitePassword" class="block text-sm font-medium text-muted">
                            Password <span class="text-red-500" aria-hidden="true">*</span>
                        </label>
                        <div class="relative">
                            <input [type]="showInvitePassword ? 'text' : 'password'" id="invitePassword" name="invitePassword" autocomplete="new-password"
                                   [(ngModel)]="newUser.password"
                                   class="block w-full rounded-lg border border-border bg-white px-3 py-2.5 pr-10 text-sm text-strong shadow-sm placeholder:text-subtle/70 transition-shadow focus:outline-none focus:ring-0 focus:!border-primary focus:shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.25)]"/>
                            <button type="button"
                                    class="absolute inset-y-0 right-0 flex items-center px-3 text-muted hover:text-strong"
                                    (click)="showInvitePassword = !showInvitePassword"
                                    [attr.aria-label]="showInvitePassword ? 'Nascondi password' : 'Mostra password'">
                                <i class="fa" [ngClass]="showInvitePassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                            </button>
                        </div>
                    </div>
                    <div class="space-y-1.5">
                        <label for="inviteConfirmPassword" class="block text-sm font-medium text-muted">
                            Ripeti la password <span class="text-red-500" aria-hidden="true">*</span>
                        </label>
                        <div class="relative">
                            <input [type]="showInviteConfirmPassword ? 'text' : 'password'" id="inviteConfirmPassword" name="inviteConfirmPassword" autocomplete="new-password"
                                   #confirmPassword
                                   class="block w-full rounded-lg border border-border bg-white px-3 py-2.5 pr-10 text-sm text-strong shadow-sm placeholder:text-subtle/70 transition-shadow focus:outline-none focus:ring-0 focus:!border-primary focus:shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.25)]"/>
                            <button type="button"
                                    class="absolute inset-y-0 right-0 flex items-center px-3 text-muted hover:text-strong"
                                    (click)="showInviteConfirmPassword = !showInviteConfirmPassword"
                                    [attr.aria-label]="showInviteConfirmPassword ? 'Nascondi password' : 'Mostra password'">
                                <i class="fa" [ngClass]="showInviteConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div class="!px-6 !py-5 sm:!px-8 bg-canvas border-t border-border flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
            <button type="button"
                    class="inline-flex justify-center rounded-lg border border-border bg-white px-5 py-2.5 text-sm font-medium text-muted shadow-sm hover:bg-canvas transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                    (click)="closeAddUserModal()">
                Annulla
            </button>
            <button type="button"
                    class="inline-flex justify-center rounded-lg border border-transparent bg-primary px-6 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-secondary disabled:opacity-50 disabled:pointer-events-none transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                    (click)="createUser()"
                    [disabled]="isUserNotValid()"
                    aria-describedby="invite-role-help">
                Crea accesso
            </button>
        </div>
    </div>
</ngx-smart-modal>
<ngx-smart-modal #editUserPassword identifier="editUserPassword"
                 customClass="nsm-dialog-animation-fade invite-user-modal-shell"
                 (onClose)="onCloseEditUserModal()"
                 [closable]="true">
    <div class="w-full bg-white text-left" *ngIf="editUserPassword.hasData()">
        <div class="px-6 pt-6 pb-2 sm:px-8 sm:pt-8 border-b border-border">
            <p class="text-xs font-semibold uppercase tracking-wider text-primary">Team società</p>
            <h2 class="mt-2 text-xl font-semibold text-strong">Modifica accesso</h2>
            <p class="mt-3 text-sm text-subtle leading-relaxed">
                <ng-container *ngIf="isUserMister(editUserPassword.getData()); else editAccessSubtitleDefault">
                    Aggiorna le categorie assegnate e, se serve, la password di accesso al portale.
                </ng-container>
                <ng-template #editAccessSubtitleDefault>
                    Imposta una nuova password per l’accesso al portale.
                </ng-template>
            </p>
        </div>

        <div class="px-6 py-6 sm:px-8 space-y-8">
            <section class="space-y-3" aria-labelledby="edit-user-summary-heading">
                <h3 id="edit-user-summary-heading" class="text-sm font-semibold text-strong">Persona</h3>
                <div class="rounded-xl border border-border bg-canvas/80 px-4 py-3.5 space-y-2">
                    <span
                        class="inline-flex w-fit max-w-full truncate rounded-full bg-primary-soft px-2.5 py-0.5 text-xs font-medium text-primary ring-1 ring-inset ring-primary-soft">
                        {{ getUserRoleDisplayName(editUserPassword.getData().userGroupId) }}
                    </span>
                    <p class="font-semibold text-strong">
                        {{ editUserPassword.getData().firstName }} {{ editUserPassword.getData().lastName }}
                    </p>
                    <p class="text-sm text-subtle truncate">{{ editUserPassword.getData().email }}</p>
                </div>
            </section>

            <section *ngIf="isUserMister(editUserPassword.getData())"
                     class="space-y-3"
                     aria-labelledby="edit-mister-cat-heading">
                <div class="flex items-baseline gap-2 flex-wrap">
                    <h3 id="edit-mister-cat-heading" class="text-sm font-semibold text-strong">Categorie assegnate</h3>
                    <span class="text-xs text-subtle">(seleziona almeno una)</span>
                </div>
                <p id="edit-mister-cat-help" class="text-sm text-subtle">
                    Il mister vedrà convocazioni e attività solo per le categorie che selezioni qui.
                </p>
                <p *ngIf="inviteMisterCategoriesLoading" class="text-sm text-muted">Caricamento categorie…</p>
                <div *ngIf="!inviteMisterCategoriesLoading && inviteMisterCategoryOptions.length === 0"
                     class="rounded-lg border border-border bg-canvas/80 px-4 py-3 text-sm text-muted">
                    Non risultano categorie per la stagione corrente. Crea le categorie in anagrafia o verifica la stagione, poi riprova.
                </div>
                <div *ngIf="!inviteMisterCategoriesLoading && inviteMisterCategoryOptions.length > 0"
                     class="w-full"
                     aria-labelledby="edit-mister-cat-heading"
                     aria-describedby="edit-mister-cat-help">
                    <welldone-multiselect
                            *ngIf="editMisterCategoriesReady"
                            [placeholder]="'Cerca e seleziona una o più categorie'"
                            [settings]="TypeDropdownSettings"
                            [data]="inviteMisterCategoryOptions"
                            [(ngModel)]="editMisterCategoriesSelected"
                            name="edit-mister-categories">
                    </welldone-multiselect>
                    <p *ngIf="!editMisterCategoriesReady" class="text-sm text-muted">Caricamento categorie assegnate…</p>
                </div>
            </section>

            <section class="space-y-4" aria-labelledby="edit-password-heading">
                <h3 id="edit-password-heading" class="text-sm font-semibold text-strong">
                    {{ isUserMister(editUserPassword.getData()) ? 'Nuova password (facoltativa)' : 'Nuova password' }}
                </h3>
                <p class="text-sm text-subtle">
                    <ng-container *ngIf="isUserMister(editUserPassword.getData()); else editPwdRequiredHelp">
                        Lascia vuoto se non vuoi cambiare la password adesso.
                    </ng-container>
                    <ng-template #editPwdRequiredHelp>
                        Inserisci e conferma la nuova password per aggiornare l’accesso.
                    </ng-template>
                </p>
                <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div class="space-y-1.5">
                        <label for="editNewPassword" class="block text-sm font-medium text-muted">
                            Password
                            <span *ngIf="!isUserMister(editUserPassword.getData())" class="text-red-500" aria-hidden="true">*</span>
                        </label>
                        <input type="password" id="editNewPassword" name="editNewPassword" autocomplete="new-password"
                               [(ngModel)]="newPassword"
                               class="block w-full rounded-lg border border-border bg-white px-3 py-2.5 text-sm text-strong shadow-sm placeholder:text-subtle/70 transition-shadow focus:outline-none focus:ring-0 focus:!border-primary focus:shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.25)]"/>
                    </div>
                    <div class="space-y-1.5">
                        <label for="editResubmitPassword" class="block text-sm font-medium text-muted">
                            Ripeti la password
                            <span *ngIf="!isUserMister(editUserPassword.getData())" class="text-red-500" aria-hidden="true">*</span>
                        </label>
                        <input type="password" id="editResubmitPassword" name="editResubmitPassword" autocomplete="new-password"
                               [(ngModel)]="resubmitPassword"
                               class="block w-full rounded-lg border border-border bg-white px-3 py-2.5 text-sm text-strong shadow-sm placeholder:text-subtle/70 transition-shadow focus:outline-none focus:ring-0 focus:!border-primary focus:shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.25)]"/>
                    </div>
                </div>
            </section>
        </div>

        <div class="!px-6 !py-5 sm:!px-8 bg-canvas border-t border-border flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
            <button type="button"
                    class="inline-flex justify-center rounded-lg border border-border bg-white px-5 py-2.5 text-sm font-medium text-muted shadow-sm hover:bg-canvas transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                    (click)="closeEditUserModal()">
                Annulla
            </button>
            <button type="button"
                    class="inline-flex justify-center rounded-lg border border-transparent bg-primary px-6 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-secondary disabled:opacity-50 disabled:pointer-events-none transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                    (click)="saveEditTeamUser()"
                    [disabled]="!isEditTeamUserValid()">
                Salva modifiche
            </button>
        </div>
    </div>
</ngx-smart-modal>
<ngx-smart-modal #editDocumentModal identifier="editDocumentModal" (onClose)="clearModalData('editDocumentModal')">
    <ng-container *ngIf="editDocumentModal.hasData()">
        <div class="welldone-card-header">
            Modifica documento
        </div>
        <div class="welldone-card-body">
            <form #athleteDocumentEditForm="ngForm" class="w-100">

                <div class="container-fluid p-0">
                    <div class="row mb-3">
                        <div class="col-4">
                            <span class="required">Nome documento</span>
                        </div>
                        <div class="col-8">
                            <input type="text" class="form-control form-control-solid"
                                   [(ngModel)]="editDocumentModal.getData().name" name="document-name" required/>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4"><span>Descrizione</span></div>
                        <div class="col-8"><textarea class="form-control form-control-solid"
                                                     [(ngModel)]="editDocumentModal.getData().description"
                                                     name="document-description"></textarea></div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4"><span class="required">Tipologia documento</span></div>
                        <div class="col-8">
                            <welldone-multiselect
                                    [placeholder]="'Seleziona tipologia documento'"
                                    [settings]="TypeDropdownSettings"
                                    [data]="documentTypes"
                                    [(ngModel)]="editDocumentSelectedTypes"
                                    name="edit-document-types">
                            </welldone-multiselect>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4"><span class="required"> E' obbligatorio</span></div>
                        <div class="col-8">
                            <select class="form-control form-select form-select-solid"
                                    [(ngModel)]="editDocumentModal.getData().isMandatory" name="document-mandatory"
                                    required>
                                <option value="1" [selected]="editDocumentModal.getData().isMandatory == 1">
                                    Sì
                                </option>
                                <option value="0" [selected]="editDocumentModal.getData().isMandatory == 0">
                                    No
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4"><span class="required">Ha una data di scadenza?</span></div>
                        <div class="col-8">
                            <select class="form-control form-select form-select-solid"
                                    [(ngModel)]="editDocumentModal.getData().hasExpirationDate"
                                    name="document-expire" required>
                                <option value="1" [selected]="editDocumentModal.getData().hasExpirationDate == 1">
                                    Sì
                                </option>
                                <option value="0" [selected]="editDocumentModal.getData().hasExpirationDate == 0">
                                    No
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4"><span class="required">È un documento primario?</span></div>
                        <div class="col-8">
                            <select class="form-control form-select form-select-solid"
                                    [(ngModel)]="editDocumentModal.getData().primaryDocument"
                                    name="document-expire" required>
                                <option value="1" [selected]="editDocumentModal.getData().primaryDocument == 1">
                                    Sì
                                </option>
                                <option value="0" [selected]="editDocumentModal.getData().primaryDocument == 0">
                                    No
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <label for="company-model-document"
                                class="form-label">Modello documento</label>
                        </div>
                        <div class="col-8">
                        <input type="file" class="form-control form-control-solid" id="company-model-document"
                               aria-describedby="model-document" aria-label="Upload"
                               (change)="chooseDocumentModel($event)"
                               name="model-document"
                        />
                    </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="welldone-card-footer">
            <button class="btn btn-primary" [disabled]="athleteDocumentEditForm.invalid || !editDocumentSelectedTypes || editDocumentSelectedTypes.length === 0"
                    (click)="updateDocument(editDocumentModal.getData())">Aggiorna
            </button>
        </div>
    </ng-container>
</ngx-smart-modal>
